'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'starfighter-twin-ion-engine-advanced';
var width = 576;
var height = 512;
var aliases = ["starfighter-alt-advanced"];
var unicode = 'e28e';
var svgPathData = 'M152.3 52.8c11.5-13.4 9.9-33.6-3.5-45.1s-33.6-9.9-45.1 3.5l-88.3 103C5.5 125.8 0 140.6 0 155.8L0 356.2c0 15.3 5.5 30.1 15.4 41.7l88.3 103c11.5 13.4 31.7 15 45.1 3.5s15-31.7 3.5-45.1l-88.3-103 0-55.4 75.6 15.1C163.3 374.6 220.8 416 288 416s124.7-41.4 148.4-100.1l75.6-15.1 0 48-89 111.2c-11 13.8-8.8 33.9 5 45s33.9 8.8 45-5l89-111.2c9.1-11.3 14-25.4 14-40l0-200.3c0-16.1-6.1-31.6-17-43.4L471.5 10.3c-12-13-32.2-13.8-45.2-1.8s-13.8 32.2-1.8 45.2l87.5 94.8 0 62.7-75.6-15.1C412.7 137.4 355.2 96 288 96S163.3 137.4 139.6 196.1l-75.6 15.1 0-55.4 88.3-103zM288 160a96 96 0 1 1 0 192 96 96 0 1 1 0-192zm0 152a56 56 0 1 0 0-112 56 56 0 1 0 0 112z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faStarfighterTwinIonEngineAdvanced = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;